import { XMarkIcon } from '@heroicons/react/24/outline';
import { useEffect, useRef } from 'react';
import { Headline } from './Headline';

export default function Modal({
  isOpen,
  setIsOpen,
  headline,
  children,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  headline: string;
  children?: React.ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      ref.current?.showModal();
    } else {
      document.body.style.overflow = '';
      ref.current?.close();
    }
  }, [isOpen]);

  return (
    <>
      <dialog
        ref={ref}
        onClick={({ target }: { target: any }) => {
          if (target.isSameNode(ref.current)) {
            setIsOpen(false);
          }
        }}
        onClose={() => setIsOpen(false)}
        className="rounded-xl shadow-md bg-white border p-4 w-full max-w-md"
      >
        <div className="flex justify-between mb-3">
          <Headline>{headline}</Headline>
          <button onClick={() => setIsOpen(false)}>
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
        <div>{children}</div>
      </dialog>
    </>
  );
}
